import React, {ReactNode} from 'react';

export function Placeholder({text}: {text?: ReactNode}) {
    return <div className="priority-editor__placeholder">{text}</div>;
}
